import React, { useState } from 'react';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import AccurityIcon from '../../../icon/components/AccurityIcon';
import FrequencyTableRow from './FrequencyTableRow';
var LOAD_MORE_AMOUNT = 5;
// sort data in descending order
var dataSortFn = function (a, b) { return b.value - a.value; };
var FrequencyTable = function (_a) {
    var mostOccurring = _a.mostOccurring, leastOccurring = _a.leastOccurring, distinctCount = _a.distinctCount, totalCount = _a.totalCount, dataType = _a.dataType;
    var _b = useState(5), groupSize = _b[0], setGroupSize = _b[1];
    mostOccurring.sort(dataSortFn);
    leastOccurring.sort(dataSortFn);
    var firstGroup = mostOccurring.slice(0, groupSize);
    var secondGroup = leastOccurring.slice(-groupSize);
    var numberOfHiddenPairs = distinctCount - firstGroup.length - secondGroup.length;
    var canLoadMore = groupSize <= 15;
    var handleLoadMore = function () {
        if (canLoadMore) {
            setGroupSize(function (q) { return q + LOAD_MORE_AMOUNT; });
        }
    };
    var loadMoreButton = (React.createElement(Button, { variant: 'text', color: 'primary', onClick: handleLoadMore },
        "LOAD MORE (",
        numberOfHiddenPairs,
        ")"));
    var rowRenderer = function (pair, idx) { return React.createElement(FrequencyTableRow, { totalCount: totalCount, pair: pair, dataType: dataType, key: idx }); };
    return (React.createElement("div", { className: "frequencyTable" },
        React.createElement(TableContainer, { sx: { maxHeight: 440, paddingRight: '12px' } },
            React.createElement(Table, { size: 'small', stickyHeader: true },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, { className: "frequencyTable__row" },
                        React.createElement(TableCell, null, "Value"),
                        React.createElement(TableCell, { align: 'right' },
                            React.createElement(AccurityIcon, { iconName: "mui:ArrowDownward", fontSize: 'small', className: "frequencyTable__sortIcon" }),
                            React.createElement("span", null, "Count")),
                        React.createElement(TableCell, { align: 'right', className: "frequencyTable__thermometerCell" }, "%"))),
                React.createElement(TableBody, null,
                    firstGroup.map(rowRenderer),
                    numberOfHiddenPairs > 0 && React.createElement(TableRow, null,
                        React.createElement(TableCell, { colSpan: 3, align: 'center' }, canLoadMore
                            ? loadMoreButton
                            : React.createElement("span", null,
                                numberOfHiddenPairs,
                                " more entries not displayed"))),
                    secondGroup.map(rowRenderer))))));
};
export default FrequencyTable;
//# sourceMappingURL=FrequencyTable.js.map